import { FC } from 'react';

const DashboardLoader: FC = () => (
  <div className='flex flex-col items-center justify-center min-h-[400px] w-full gap-4 animate-in fade-in duration-500'>
    <div className='relative bg-white dark:bg-gray-800 p-4 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-700'>
      <img
        src='/dav-safaris-logo.png'
        alt='Dav Safaris'
        className='w-12 h-12 object-contain animate-pulse rounded-xl'
      />
    </div>
  </div>
);

export default DashboardLoader;
